<script>
   /**************************************************************/
   /* Excluded variables pane                                    */
   /* -------------------------                                  */
   /* show how many variables have been excluded                 */
   /**************************************************************/

   import { Container, ButtonCancel } from 'svelte-controls-basic';


   let {
      exclvars,
      resetExclvars,
   } = $props();
</script>

{#if exclvars && exclvars.length > 0 }
   <!-- dataset is loaded - show info and cancel button -->
   <Container>
      <p class="exclvars">
         <span style="color:#a0a0a0;">Excluded</span>
         <span style="color:#504040;">{exclvars.length}</span>
         <span style="color:#a0a0a0;">variables</span>
      </p>
      <ButtonCancel onclick={resetExclvars} />
   </Container>
{/if}


<style>
   .exclvars{
      line-height: 1.5em;
      text-align: left;
      padding: 0.5em 0;
      flex: 0 0 80%;
   }
</style>